import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next'

import RadioButton from '../../common/inputs/RadioButton';
import SecondaryButton from '../../common/buttons/SecondaryButton';
import PrimaryButton from '../../common/buttons/PrimaryButton';

import { hashCode } from '../../../utils/consts';
import { translateQuestionTypes } from './questionTypesConsts';
import useStyles from './styles';


const QuestionType = ({ type, onHide, onConfirm }) => {
  const { t } = useTranslation(['translation']);
  const {
    SINGLE_CHOICE_QUESTION,
    MULTIPLE_CHOICE_QUESTION,
    OPEN_QUESTION,
    RATING_QUESTION,
  } = translateQuestionTypes(t);
  const options = [
    SINGLE_CHOICE_QUESTION, MULTIPLE_CHOICE_QUESTION, OPEN_QUESTION, RATING_QUESTION,
  ];
  const defaultIndex = options.indexOf(type) || 0;
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(defaultIndex);

  const classes = useStyles();
  return (
    <React.Fragment>
      <h3 className={classes.modalTitle}>{t('CAMPAIGN.QUESTIONNAIRE.MODAL_TITLE')}</h3>
      <div className={classes.modalContainer}>
        {options.map((val, i) => (
          <RadioButton
            key={hashCode(val)}
            id={i.toString()}
            name={i.toString()}
            title={val}
            checked={selectedOptionIndex === i}
            onToggle={() => { setSelectedOptionIndex(i); }}
            className={classes.question}
          />
        ))}
      </div>
      <div className={classes.buttonsFooter}>
        <SecondaryButton type="button" onClick={onHide} className={classes.button}>
          {t('CAMPAIGN.QUESTIONNAIRE.MODAL_CANCEL_BUTTON')}
        </SecondaryButton>
        <PrimaryButton type="button" onClick={() => { onConfirm(options[selectedOptionIndex]); }} className={classes.button}>
          {t('CAMPAIGN.QUESTIONNAIRE.MODAL_NEXT_BUTTON')}
        </PrimaryButton>
      </div>
    </React.Fragment>
  );
};


QuestionType.propTypes = {
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default QuestionType;
